import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { onConfirmChangeForm } from '../handler/KnowledgeTicketHandler';

export default function DialogSelectFormKnowledgeTicket({argsAll}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const onCloseDialogReject = () => {
        argsAll.setIsOpenDialogSelectForm({isOpen: false, value: ''});
    };

    return (
        <Dialog
            open={argsAll.isOpenDialogSelectForm.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('USER04MSG017')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={async () => await onConfirmChangeForm(argsAll.isOpenDialogSelectForm.value, argsAll)}
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
